import type { Dispatch } from '@avalara/types/actions';
import type { Result } from '@avalara/types/index';
import type { ProductClientDetails } from '@avalara/types/product-detail';

import conf from '../../conf';
import { setProductDetail } from '../../store/product-detail';
import fetch from '../fetch';
import { getSystemErrorMessaging } from './error';

export const fetchProductDetail = (productKey: string) => async (dispatch: Dispatch) => {
  const result: Result<ProductClientDetails> = await fetch(dispatch)(`${conf.API_URL}/api/products/${productKey}`);

  if (result.ok) {
    dispatch(setProductDetail(result.value));
  } else if (result.status === 404) {
    dispatch(setProductDetail('NOT_FOUND'));
  } else {
    dispatch(setProductDetail('ERROR'));
    dispatch(getSystemErrorMessaging({ errorCode: 'genericError' }));
  }
};
